import styled from 'styled-components';

import Tooltip from 'components/shared/Tooltip';
import Upload from 'hooks/useDirectUpload/Upload';
import colors from 'styles/theme/colors';
import { BodySmallBold } from 'styles/typography';
import ErrorWarningIcon from 'svg/ErrorWarningIcon';
import XIcon from 'svg/XIcon2';

type InternalAttachmentProps = {
  upload: Upload;
  handleDelete: (id) => void;
};

const InternalAttachment = ({ upload, handleDelete }: InternalAttachmentProps) => {
  return (
    <FileItemContainer key={upload.id} $error={upload.hasError} onClick={(e) => e.stopPropagation()}>
      <FileItemContent>
        {upload.hasError && (
          <Tooltip text='File failed to process and will not be included in the summarization.'>
            <IconContainer>
              <ErrorWarningIcon />
            </IconContainer>
          </Tooltip>
        )}
        <FileName>{upload.filename}</FileName>
        <Tooltip text='Remove File'>
          <DeleteButton onClick={() => handleDelete(upload.id)}>
            <XIcon width={8} height={8} color={colors.black} style={{ cursor: 'pointer' }} />
          </DeleteButton>
        </Tooltip>
      </FileItemContent>
    </FileItemContainer>
  );
};

export default InternalAttachment;

const FileItemContainer = styled.div<{ $error: boolean }>`
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.black02};
  border: 0.5px solid ${({ theme, $error }) => ($error ? theme.colors.accentRed : theme.colors.black15)};
  border-radius: ${({ theme }) => theme.dimensions.borderRadius};
  padding: 4px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 32px;
  max-width: 320px;
  text-overflow: ellipsis;
  cursor: default;
`;

const FileItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > :first-child {
    flex: 1;
  }
`;
const IconContainer = styled.div`
  width: 16px;
`;
const FileName = styled(BodySmallBold)`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.primaryBlue};
  font-weight: bold;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

const DeleteButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
